import primaryComponents from "../../../../primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";

export const AdditionalDetailsForm = ({
  pOForm,
  setPOForm = () => {},
  ...validationParams
}) => {
  const { register, control } = validationParams;

  return (
    <div className={`${globalStyles.cardWithBorder} white`}>
      <h4 className="mb-4 font-weight-normal">Additional Details</h4>

      <div className={"d-flex flex-column flex-md-row"} style={{ gap: "15px" }}>
        <div
          className={`d-flex flex-column w-100 ${globalStyles.cardWithBorder}`}
        >
          <h6 className="gray--text ">Shipping Details</h6>
          <primaryComponents.InputField
            control={control}
            name={"name"}
            register={register}
            label="Name"
            placeholder={"Enter name"}
            classNames="white"
            value={pOForm?.shipping_details?.name}
            onChange={({ target: { value } }) => {
              setPOForm((prev) => ({
                ...prev,
                shipping_details: {
                  ...prev.shipping_details,
                  name: value,
                },
              }));
            }}
          />
          <primaryComponents.InputField
            control={control}
            name={"address"}
            register={register}
            label="Address"
            placeholder={"Enter address"}
            classNames="white"
            value={pOForm?.shipping_details?.address}
            onChange={({ target: { value } }) => {
              setPOForm((prev) => ({
                ...prev,
                shipping_details: {
                  ...prev.shipping_details,
                  address: value,
                },
              }));
            }}
          />
          <primaryComponents.PhoneNumberInputFieldV2
            control={control}
            name={"phone_number"}
            register={register}
            label="Phone Number"
            placeholder={"Enter phone number"}
            classNames="white"
            value={pOForm?.shipping_details?.phone_number}
            onChange={({ target: { value } }) => {
              setPOForm((prev) => ({
                ...prev,
                shipping_details: {
                  ...prev.shipping_details,
                  phone_number: value,
                },
              }));
            }}
          />

          <primaryComponents.DateInputV2
            control={control}
            name={"delivery_date"}
            register={register}
            label={"Delivery Date"}
            placeholder="Select delivery date"
            classNames="white"
            value={pOForm?.shipping_details?.delivery_date}
            onChange={({ target: { value } }) => {
              setPOForm((prev) => ({
                ...prev,
                shipping_details: {
                  ...prev.shipping_details,
                  delivery_date: value,
                },
              }));
            }}
          />
        </div>
        <div className={`w-100 ${globalStyles.cardWithBorder}`}>
          <primaryComponents.TextArea
            control={control}
            name={"notes"}
            register={register}
            label="Comments or Special Instruction"
            value={pOForm?.notes}
            onChange={({ target: { value } }) => {
              setPOForm((prev) => ({
                ...prev,
                notes: value,
              }));
            }}
          />
        </div>
      </div>
    </div>
  );
};
